import { Action } from '@ngrx/store';

import { IMemberEventBooking } from '@shared/shared/interfaces/member-event.interfaces';
import { IStringValuePayload } from '@shared/store/interfaces/store.interfaces';

// Get Booking
export const GET_BOOKING = '[Member Event] Get Booking';
export const GET_BOOKING_SUCCESS = '[Member Event] Get Booking Success';
export const GET_BOOKING_FAILURE = '[Member Event] Get Booking Failure';

export class GetBooking implements Action {
  readonly type = GET_BOOKING;

  constructor(
    public payload: {
      id: string;
    }
  ) {}
}

export class GetBookingSuccess implements Action {
  readonly type = GET_BOOKING_SUCCESS;

  constructor(public payload: IMemberEventBooking) {}
}

export class GetBookingFailure implements Action {
  readonly type = GET_BOOKING_FAILURE;

  constructor(public payload: IStringValuePayload) {}
}

// Create Booking
export const CREATE_BOOKING = '[Member Event] Create Booking';
export const CREATE_BOOKING_SUCCESS = '[Member Event] Create Booking Success';
export const CREATE_BOOKING_FAILURE = '[Member Event] Create Booking Fail';

export class CreateBooking implements Action {
  readonly type = CREATE_BOOKING;
}

export class CreateBookingSuccess implements Action {
  readonly type = CREATE_BOOKING_SUCCESS;

  constructor(public payload: IMemberEventBooking) {}
}

export class CreateBookingFailure implements Action {
  readonly type = CREATE_BOOKING_FAILURE;

  constructor(public payload: IStringValuePayload) {}
}

// Update Booking
export const UPDATE_BOOKING = '[Member Event] Update Booking';
export const UPDATE_BOOKING_SUCCESS = '[Member Event] Update Booking Success';
export const UPDATE_BOOKING_FAILURE = '[Member Event] Update Booking Failure';
export const UPDATE_BOOKING_RESET = '[Member Event] Update Booking Reset';

export class UpdateBooking implements Action {
  readonly type = UPDATE_BOOKING;

  constructor(
    public payload: {
      data?: Record<string, any>;
      id: number | string;
    }
  ) {}
}

export class UpdateBookingSuccess implements Action {
  readonly type = UPDATE_BOOKING_SUCCESS;

  constructor(public payload: Record<string, any>) {}
}

export class UpdateBookingFailure implements Action {
  readonly type = UPDATE_BOOKING_FAILURE;

  constructor(public payload: IStringValuePayload) {}
}

export class UpdateBookingReset implements Action {
  readonly type = UPDATE_BOOKING_RESET;
}

// Update Booking Local
export const UPDATE_BOOKING_LOCAL = '[Member Event] Update Booking Local';
export const UPDATE_BOOKING_LOCAL_SUCCESS = '[Member Event] Update Booking Local Success';
export const UPDATE_BOOKING_LOCAL_FAILURE = '[Member Event] Update Boking Local Failure';

export class UpdateBookingLocal implements Action {
  readonly type = UPDATE_BOOKING_LOCAL;

  constructor(
    public payload: {
      data: Record<string, any>;
    }
  ) {}
}

export class UpdateBookingLocalSuccess implements Action {
  readonly type = UPDATE_BOOKING_LOCAL_SUCCESS;

  constructor(public payload: IMemberEventBooking) {}
}

export class UpdateBookingLocalFailure implements Action {
  readonly type = UPDATE_BOOKING_LOCAL_FAILURE;

  constructor(public payload: IStringValuePayload) {}
}

// Clear Booking Local
export const CLEAR_BOOKING_LOCAL = '[Member Event] Clear Booking Local';
export const CLEAR_BOOKING_LOCAL_SUCCESS = '[Member Event] Clear Booking Local Success';
export const CLEAR_BOOKING_LOCAL_FAILURE = '[Member Event] Clear Booking Local Failure';

export class ClearBookingLocal implements Action {
  readonly type = CLEAR_BOOKING_LOCAL;
}

export class ClearBookingLocalSuccess implements Action {
  readonly type = CLEAR_BOOKING_LOCAL_SUCCESS;
}

export class ClearBookingLocalFailure implements Action {
  readonly type = CLEAR_BOOKING_LOCAL_FAILURE;

  constructor(public payload: IStringValuePayload) {}
}

export type MemberEventBookingActions =
  | GetBooking
  | GetBookingSuccess
  | GetBookingFailure
  | CreateBooking
  | CreateBookingSuccess
  | CreateBookingFailure
  | UpdateBooking
  | UpdateBookingSuccess
  | UpdateBookingFailure
  | UpdateBookingReset
  | UpdateBookingLocal
  | UpdateBookingLocalSuccess
  | UpdateBookingLocalFailure
  | ClearBookingLocal
  | ClearBookingLocalSuccess
  | ClearBookingLocalFailure;
